import { render, staticRenderFns } from "./OnlineOrderCard.vue?vue&type=template&id=d88f5aae&scoped=true"
import script from "./OnlineOrderCard.vue?vue&type=script&lang=js"
export * from "./OnlineOrderCard.vue?vue&type=script&lang=js"
import style0 from "./OnlineOrderCard.vue?vue&type=style&index=0&id=d88f5aae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88f5aae",
  null
  
)

export default component.exports